module.exports = __webpack_public_path__ + "media/images/icons/flags/MY-31b6d60063d7c53df6ce0da7723f173e.svg";